const VarietyModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH(state, payload) {
      state.data = []
      state.data = payload.Varietys
    },
    // DELETE: (state, payload) => {
    //   var index = state.data.findIndex(data => data.productid === payload)
    //   state.data.splice(index, 1)
    // }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/getVariety`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    // async delete({ commit }, payload) {
    //   try {
    //     await axios.delete(`getProductBy/id/${payload}`)
    //     commit('DELETE', payload)
    //   } catch (error) {
    //     throw new Error(error)
    //   }
    // }
  },
  getters: {
    getAll: state => {
      return state.data
    },
  }
}

export default VarietyModule



// WEBPACK FOOTER //
// ./src/store/modules/variety/variety.js